module.exports = __webpack_public_path__ + "img/40_37_014_190.00ef3aa7.jpg";